<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información de la Tarjeta">
          <b-table 
              small 
              responsive="sm" 
              :items="tarjetaPlasticoDatos" 
              :fields="campos">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos de la Tarjeta</b-dropdown-item>
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>      
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetaPlastico/getField',
  mutationType: 'tarjetaPlastico/updateField',
});

export default {
  name: 'TarjetaPlasticoData',
  components: {
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  data: () => {
    return {
      tarjetaId: 0,
      id: 0,

      campos: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      tableBusy: false,
    }
  },
  created() {
    this.id= this.$route.params.tarjetaId;
    this.id= this.$route.params.id;
    
    this.tableBusy = true;
    this.$store.dispatch('tarjetaPlastico/getTarjetaPlasticoDatos', this.id)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'tarjetaPlasticoDatos',
    ]),
  },  
  methods: {
    goBack() {
      this.$router.push({ name: "TarjetasPlasticos",
                          params: { tarjetaId: this.tarjetaId }});
    },
    editar() {
      this.$router.push({ name: 'TarjetaPlasticoEdit', 
                          params: { id: this.id }});
    },
  }
}
</script>
